import React from 'react';
import Navbar from '../components/landing/Navbar';
import HeroSection from '../components/landing/HeroSection';
import FeaturesSection from '../components/landing/FeaturesSection';
import DemoCalloutSection from '../components/landing/DemoCalloutSection';
import CTASection from '../components/landing/CTASection';
import Footer from '../components/landing/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-ep-background" data-testid="home-page">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <DemoCalloutSection />
        {/* TestimonialsSection removed - will be added when we have real testimonials */}
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
